export const encodeImageUrl = (url?: string | null): string => {
    if (!url) {
        return '';
    }

    return encodeURI(decodeURI(url));
};
